export const API_SERVER_AUTH_TOKEN_TYPE = 'Bearer';